export const endpoint = {
  user: 'user',
  changePassword: (id: number) => `user/${id}/password`,
  changePersonId: (id: number) => `user/${id}/personId`,
  role: {
    data: 'role',
    edit: 'role',
    add: 'role'
  },
  extraInfo: 'user/extraInfo/fields/options',
  personExcluded: 'user/personOptionsCollection/fieldNodes',
  addDatabaseAccount: (id: number) => `user/${id}/adminappAccount`,
  resetDatabaseAccount: (id: number) => `user/${id}/adminappAccount/password`,
  deleteDatabaseAccount: (id: number) => `user/${id}/adminappAccount`,
  codetablesAccess: 'optionsCollection/access',
  users: 'user/search'
};

export const userOptions = {
  usertype: 'user/userType/options',
  location: 'user/location/options',
  unit: 'user/unit/options',
  language: 'user/language/options',
  role: 'user/role/options',
  mainUsergroup: 'user/usergroup/main/options',
  currentUsergroup: (selectedMainUsergroup) => `user/usergroup/main/${selectedMainUsergroup}/current/options`,
  applications: 'user/operationaccess/application/options',
  operations: (applicationId) => `user/operationaccess/application/${applicationId}/operation/options`,
  extendedAccess: {
    caseType: 'user/extendedaccess/casetype/options',
    unit: (caseType) => `user/extendedaccess/casetype/${caseType}/unit/options`
  },
  responsibleForUnit: {
    caseType: 'user/responsibleforunit/casetype/options',
    unit: (caseType) => `user/responsibleforunit/casetype/${caseType}/unit/options`
  },
  restrictedAccess: {
    caseType: 'user/restrictedAccess/casetype/options',
    unit: (caseType) => `user/restrictedAccess/casetype/${caseType}/unit/options`
  },
  accesstoscreen: {
    caseType: 'user/accesstoscreen/casetype/options',
    screen: (caseType) => `user/accesstoscreen/casetype/${caseType}/screen/options`
  },
  defaultValues: {
    optionsCollections: 'user/defaultValues/optionsCollections/options',
    caseTypes: 'user/defaultValues/caseTypes/options',
    values: (optionsCollectionId) =>
      `user/defaultValues/optionsCollection/${optionsCollectionId}/options`,
    valuesFields: (optionsCollectionId) => `user/defaultValues/optionsCollection/${optionsCollectionId}/fields/options`
  },
  accessToUserGroups: 'user/usergroup/options',
  extraInfoOptions: (extraInfoId) => `user/extraInfo/${extraInfoId}/options`,
  subscriptionOptions: 'user/subscription/options'
};

export const roleOptions = {
  ...userOptions,
  applications: 'role/operationaccess/application/options',
  defaultRole: 'role/default'
};
